import baseStyles from '../Base/Base.styles'
import merge from 'lodash/merge'
import BaseDividersStyles from '../BaseDividers/BaseDividers.styles'
import baseBackgroundStyles from '../BaseBackground/BaseBackground.styles'

const alignmentMap = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
}

const contentWidthMap = {
  narrow: '600px',
  normal: '900px',
  wide: '1100px',
  fluid: '100%',
}

export default properties => {
  const { base, background, height, verticalAlignment, width, dividers } = properties

  let jss = {
    root: {
      ...baseStyles(base),
      width: '100%',
      zIndex:0,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& .content': {
        // zIndex: 1,
        justifyContent: alignmentMap[verticalAlignment],
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        alignItems: 'stretch',
        maxWidth: contentWidthMap[width],
      }
    }
  }

  if(dividers) {
    merge(jss, {
      root: {
        ...BaseDividersStyles(dividers)
      }
    })

  }

  if(height) {
    merge(jss, {
      root: {
        minHeight: height
      }
    })
  }

  if (background) {
    merge(jss, {
      root: baseBackgroundStyles(background)
    })
  }

  if(width === 'fluid') {
    merge(jss.root, {
      paddingLeft: '0px !important',
      paddingRight: '0px !important',
    })
  }

  return jss
}
